module.exports = "/images/red-circle.svg?38a148354d188b83ff612e54893e24f8";